import { Trpdbmrgr } from './Trpdbmrgr';
import { Trpdbvoucher } from './Trpdbvoucher';

export class MREntry {
    public Voucher: Trpdbvoucher | undefined;
    public TRPDBMRGRLIST: Trpdbmrgr[] = [];
}